import { STRING_ACCESS_TOKEN_COMPRARTODO } from "../const/string-const";
import { isTokenExpire } from "../token";

export function isUserLoggedIn() {
    const token = localStorage.getItem(STRING_ACCESS_TOKEN_COMPRARTODO);
    if (!token) return false;
    return !isTokenExpire();
}
